export default class Export {
    public static exportCSVFile(items: any, fileTitle: string) {
        let exportedFilenmae = fileTitle + '.csv' || 'export.csv';
        items = this.convertToCSV(items);
        let blob = new Blob([items], { type: 'text/csv;charset=utf-8;' });
        if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, exportedFilenmae);
        } else {
            let link = document.createElement('a');
            if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                let url = URL.createObjectURL(blob);
                link.setAttribute('href', url);
                link.setAttribute('download', exportedFilenmae);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }

    private static convertToCSV(objArray: any) {
        console.log('objArray', objArray);
        let array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
        let str = '';
        let headers = '';
        for (let i = 0; i < array.length; i++) {
            let line = '';
            for (let index in array[i]) {
                if (true) {
                    if (i === 0) {
                        headers += index + ',';
                    }
                    if (line !== '') {
                        line += ',';
                    }
                    // array[i][index] !== null && array[i][index].toString().includes(',') includes not supported in IE
                    line += array[i][index] !== null && array[i][index] !== undefined
                                 && array[i][index].toString().indexOf(',') !== 0 ? 
                            '"' + array[i][index] + '"'
                            : array[i][index];
                }
            }
            if (i === 0) {
                str += headers + '\r\n';
                str += line + '\r\n';
            } else {
                str += line + '\r\n';
            }

        }
        console.log('str', str);
        return str;

    }

}


// WEBPACK FOOTER //
// ./src/components/common/export.tsx